import moment from 'moment';
import { ShareableItemType } from '@/app/utils/constants/ItemType';

export const lowercase = value => value.toLowerCase();

export const uppercase = value => value.toUpperCase();

export const capitalize = value => `${uppercase(value.charAt(0))}${lowercase(value).slice(1)}`;

export const types = (value) => {
  const words = value.split('_');
  return words.map(word => capitalize(word)).join(' ');
};

export const sharedTypes = (value) => {
  if (value === null || value === undefined || value === '') {
    return '';
  }
  const type = ShareableItemType[value];
  if (type === undefined) {
    return '';
  }

  return type;
};

export const momentFilter = (value, format) => {
  if (value === null || value === undefined || format === undefined) {
    return '';
  }
  const adjustedValue = moment(value).hour(12);
  if (format === 'from') {
    return adjustedValue.fromNow();
  }
  return adjustedValue.format(format);
};

export const dollar = (value) => {
  const formatter = new Intl.NumberFormat('en-AU', {
    style: 'currency',
    currency: 'AUD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

  return formatter.format(value);
};

export const percent = (value) => {
  const formatter = new Intl.NumberFormat('en-AU', {
    style: 'percent',
    maximumFractionDigits: 6,
  });

  return formatter.format(value);
};

export default {
  install(Vue) {
    // lowercase
    Vue.filter('lowercase', lowercase);
    // uppercase
    Vue.filter('uppercase', value => uppercase(value));
    // capitalize
    Vue.filter('capitalize', value => capitalize(value));
    // Format Types
    Vue.filter('types', value => types(value));
    // Shared Types
    Vue.filter('sharedTypes', value => sharedTypes(value));
    // Moment filter
    Vue.filter('moment', (value, format) => momentFilter(value, format));
    // Dollar
    Vue.filter('dollar', value => dollar(value));
    // Percent
    Vue.filter('percent', value => percent(value));
  },
};
